import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const PencilIcon = withSvgIcon(
    <g>
        <path d="M483.2 80.3l-68.6-68.6C406.8 3.9 396.5 0 386.2 0c-10.3 0-20.6 3.9-28.4 11.7L19 350.6l-.4-.4L5.1 500l139.7-25.3.4.4 338-338c15.6-15.7 15.6-41.2 0-56.8zM28.5 474.4l9.9-104.7 87.8 86.6-97.7 18.1zm116.6-28.8l-96.4-95.1L315 84.1l95.3 96.2-265.2 265.3zm280-280.1l-95.3-96.2L349 50.2l95.3 96.2-19.2 19.1zm43.3-43.3l-9.3 9.3-95.3-96.2 8.9-8.9c3.6-3.6 8.4-5.6 13.6-5.6 5.2 0 10 2 13.6 5.6L468.5 95c7.4 7.6 7.4 19.8-.1 27.2z" />
    </g>
);
